import { TFunction } from "i18next";

/** English fallbacks for `modification.short.<id>`. */
export const MODIFICATION_SHORT: Record<string, string> = {
  none: "None",
  modification: "Modification",
  adaptation: "Adaptation",
  alternative: "Alternative test",
};

/** English fallbacks for `classes.healthFlag.<id>` (ids from `HealthFlag` in src/models). */
export const HEALTH_FLAG_LABEL: Record<string, string> = {
  asthma: "Asthma",
  cardiac: "Cardiac",
  injury: "Injury",
  other: "Other (see notes)",
};

/** Translated short name of a planned or recorded modification id. */
export const modificationLabel = (t: TFunction, id: string) =>
  t(`modification.short.${id}`, { defaultValue: MODIFICATION_SHORT[id] ?? id });

/** Translated name of a health-flag id. */
export const healthFlagLabel = (t: TFunction, id: string) =>
  t(`classes.healthFlag.${id}`, { defaultValue: HEALTH_FLAG_LABEL[id] ?? id });
